"use client";
import Link from 'next/link';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          {/* Main Footer Section */}
          <div className="footer-main">
            <div className="footer-section">
              <div className="footer-logo">
                <img src="/img/logo.png" alt="GHG2001 Logo" />
                <p>ધોરણ ૧૦ (વર્ષ 2000–2001)</p>
                <p>School Friends Reunion</p>
              </div>
              <p className="footer-description">
                Celebrating 25 years of friendship, memories, and togetherness.
                Join us in this special reunion to reconnect with your school friends.
              </p>
            </div>


            <div className="footer_right_littlespace"></div>
            <div className="footer-section">
              <h4>Quick Links</h4>
              <ul className="footer-links">
                <li><Link href="/">Home</Link></li>
                <li><Link href="/reunion">Reunion</Link></li>
                <li><Link href="/gallery">Photo Gallery</Link></li>
                <li><Link href="/profiles">Profiles</Link></li>
                <li><Link href="/donations">Donations</Link></li>
                <li><Link href="/contact">Contact</Link></li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>Community</h4>
              <ul className="footer-links">
                <li><Link href="/nearby-friends">Nearby Friends</Link></li>
                <li><Link href="/chat">Chat Room</Link></li>
                <li><Link href="/registration">Join Us</Link></li>
                <li><Link href="/login">Login</Link></li>
              </ul>
            </div>

          </div>


          {/* Footer Bottom */}
          <div className="footer-bottom">
            <div className="footer-bottom-content">
              <p>&copy; {new Date().getFullYear()} GHG2001. All rights reserved. Design and Developed by <a href="http://greyphyte.com" target="_blank" rel="noopener noreferrer">Greyphyte</a></p>

            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .footer {
          background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
          color: white;
          margin-top: auto;
          position: relative;
          overflow: hidden;
        }

        .footer::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: #0e8280;
        }

        .footer-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }

        .footer-content {
          padding: 3rem 0 1rem;
        }

        .footer-main {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 2rem;
          margin-bottom: 2rem;
        }

        .footer-section h4 {
          color: #ecf0f1;
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 1rem;
          position: relative;
        }

        .footer-section h4::after {
          content: '';
          position: absolute;
          bottom: -5px;
          left: 0;
          width: 30px;
          height: 2px;
          background: #0e8280;
        }

        .footer-logo img {
            width: 150px;
            height: auto;
            margin-bottom: 1rem;
        }

        .footer-logo p {
          margin: 0.25rem 0;
          color: #bdc3c7;
          font-size: 0.9rem;
        }

        .footer-description {
          color: #bdc3c7;
          line-height: 1.6;
          margin-bottom: 1rem;
        }

        .footer-links {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .footer-links li {
          margin-bottom: 0.5rem;
        }

        .footer-links a {
          color: #bdc3c7;
          text-decoration: none;
          transition: all 0.3s ease;
          display: inline-block;
        }

        .footer-links a:hover {
          color: #0e8280;
          transform: translateX(5px);
        }

        .footer-contact p {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          margin-bottom: 0.75rem;
          color: #bdc3c7;
        }

        .footer-contact svg {
          flex-shrink: 0;
          color: #0e8280;
        }

        .footer-social {
          text-align: center;
          margin-bottom: 2rem;
          padding-top: 1rem;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
        }

        .footer-social h4 {
          margin-bottom: 1rem;
        }

        .social-links {
          display: flex;
          justify-content: center;
          gap: 1rem;
        }

        .social-link {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.1);
          color: #bdc3c7;
          text-decoration: none;
          transition: all 0.3s ease;
        }

        .social-link:hover {
          background: #0e8280;
          color: white;
          transform: translateY(-3px);
          box-shadow: 0 5px 15px rgba(14, 130, 128, 0.4);
        }

        .footer-bottom {
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          padding-top: 1.5rem;
          padding-bottom: 1rem;
        }

        .footer-bottom-content {
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          flex-wrap: wrap;
          gap: 1rem;
        }

        .footer-bottom p {
          margin: 0;
          color: #95a5a6;
          font-size: 0.9rem;
        }

        .footer-bottom-links {
          display: flex;
          gap: 1.5rem;
        }

        .footer-bottom-links a {
          color: #95a5a6;
          text-decoration: none;
          font-size: 0.9rem;
          transition: color 0.3s ease;
        }

        .footer-bottom-links a:hover {
          color: #0e8280;
        }

        @media (max-width: 768px) {
          .footer-main {
            grid-template-columns: 1fr;
            gap: 1.5rem;
          }

          .footer-bottom-content {
            flex-direction: column;
            text-align: center;
          }

          .footer-bottom-links {
            justify-content: center;
          }

          .social-links {
            flex-wrap: wrap;
          }

          .footer-content {
            padding: 2rem 0 1rem;
          }
        }

        @media (max-width: 480px) {
          .footer-container {
            padding: 0 15px;
          }

          .footer-logo h3 {
            font-size: 1.5rem;
          }

          .footer-contact p {
            font-size: 0.9rem;
          }
        }
      `}</style>
    </footer>
  );
}